import React, { useEffect, useMemo, useRef, useState } from 'react'
import { loadUser, loadUserTalentsByUser, loadUserTalentDocuments, loadCountry, loadCourseParticipantsByUser, deleteUser, blockUser, login, loadCertificates, loadeEmails, deleteCourseParticipant, uploadProfileImage } from '../utils/Network';
import { isImage, getDefaultName, isAdmin, getUser, getDate, BadgeClass, userAvatar } from '../utils';
import UserTalentSingleContent from './UserTalentSingleContent';
import CityName from '../components/CityName';
import Modal from 'react-modal';
import UrlEmbed from '../components/UrlEmbed';
import SendEmailModal from '../components/modals/SendEmailModal';
import UserGallery from 'cms/components/user/UserGallery';
import TabsWidget from 'cms/pages/shared/dashboard/widgets/TabsWidget';
import SendEmailComposeModal from 'cms/components/email/SendEmailComposeModal';

export default function UserTalentContent({ profile_id }) {
    const profile_image_ref = useRef(null);

    const [loading, setLoading] = useState(0);

    const [user, setUser] = useState(null);
    const [country, setCountry] = useState(null);
    const [living_country, setLivingCountry] = useState(null);
    const [current_document, setCurrentDocument] = useState(null);
    const [usertalents, setUserTalents] = useState(null);
    const [courseParticipants, setCourseParticipants] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const [confirmModalType, setConfirmModalType] = useState(false);
    const [modal_password, setModalPassword] = useState(false);
    const [modal_error, setModalError] = useState(false);
    const [modal_loading, setModalLoading] = useState(false);
    const [certificates, setCertificates] = useState(null);
    const [email_modal_is_open, setEmailModalIsOpen] = useState(null);
    const [composeEmailModalOpen, setComposeEmailModalOpen] = useState(false);
    const [emails, setEmails] = useState(null);

    var admin = getUser()

    const [activeTab, setActiveTab] = useState(null);
    const [activeTalentTab, setActiveTalentTab] = useState(null);
    const [talentDocumentCounts, setTalentDocumentCounts] = useState({});

    const mainTabs = useMemo(
        () => [
            { key: "talents", label: "Talents", icon: "fa-star" },
            { key: "gallery", label: "User gallery", icon: "fa-film" },
            { key: "emails", label: "Emails", icon: "fa-envelope" },
        ],
        []
    );

    const talentSubTabs = useMemo(
        () =>
            (usertalents || []).map((item) => {
                const name = getDefaultName(item.talent.names);
                const n = talentDocumentCounts[item.id];
                const label = n !== undefined ? `${name} (${n})` : name;
                return {
                    key: `ut_${item.id}`,
                    label,
                    icon: "fa-music",
                };
            }),
        [usertalents, talentDocumentCounts]
    );

    const resolvedTab =
        activeTab && mainTabs.some((t) => t.key === activeTab)
            ? activeTab
            : mainTabs[0]?.key ?? "gallery";

    const resolvedTalentTab =
        activeTalentTab && talentSubTabs.some((t) => t.key === activeTalentTab)
            ? activeTalentTab
            : talentSubTabs[0]?.key ?? null;

    useEffect(() => {

        if (profile_id) {
            loadUser(profile_id).then(user => {
                setUser(user);
                if (user.country_id) {
                    loadCountry(user.country_id).then(country => {
                        setCountry(country)
                    })
                }
                if (user.livingcountry_id) {
                    loadCountry(user.livingcountry_id).then(country => {
                        setLivingCountry(country)
                    })
                }

                loadUserTalentsByUser(user.user).then(usertalents => {
                    setUserTalents(usertalents.reverse())
                })

                _getCourseParticipants(user.user)

                loadCertificates(user.user).then(certificates => {
                    console.log(certificates);
                    setCertificates(certificates);
                });

                loadeEmails(1, user.email).then((data) => {
                    if (data.results) {
                        setEmails(data.results);
                    }

                });

            });




        }
    }, [profile_id]);

    useEffect(() => {
        if (!usertalents?.length) {
            setTalentDocumentCounts({});
            return;
        }
        let cancelled = false;
        Promise.all(
            usertalents.map((ut) =>
                loadUserTalentDocuments(ut.id).then((docs) => ({
                    id: ut.id,
                    count: Array.isArray(docs) ? docs.length : 0,
                }))
            )
        ).then((rows) => {
            if (cancelled) return;
            const next = {};
            rows.forEach((r) => {
                next[r.id] = r.count;
            });
            setTalentDocumentCounts(next);
        });
        return () => {
            cancelled = true;
        };
    }, [usertalents]);

    const _getCourseParticipants = (userId) => {
        loadCourseParticipantsByUser(userId).then(courseParticipants => {
            setCourseParticipants(courseParticipants)
        })
    }

    const refreshEmails = () => {
        if (!user?.email) return;
        loadeEmails(1, user.email).then((data) => {
            if (data.results) {
                setEmails(data.results);
            }
        });
    };

    const callback = (current_document) => {
        setCurrentDocument(current_document)
        setModalIsOpen(true)
    }

    const closeModal = () => {
        setModalIsOpen(false)

    }

    const openEmailModal = (e) => {
        e.preventDefault();
        setEmailModalIsOpen(true)
    }

    const openConfirmModal = (type) => {
        setConfirmModalType(type)
        setConfirmModalIsOpen(true)
    }
    const closeConfirmModal = () => {
        setConfirmModalIsOpen(false)

    }
    const closeEmailModal = () => {
        setEmailModalIsOpen(false)

    }


    const handleChange = (e) => {
        switch (e.target.name) {
            case "modal_password":
                setModalPassword(e.target.value)
                break;

            default:
                break;
        }

    }

    const modalSubmit = () => {
        switch (confirmModalType) {
            case "Delete":
                deleteThisUser()
                break;
            case "Ban":
                blockThisUser()
                break;

            default:
                break;
        }
    }

    const deleteThisUser = () => {
        setModalLoading(true)
        setModalError(false)
        if (!modal_password) {
            setModalError("Please Enter Password")
            return;
        }


        login({ email: admin.email, password: modal_password }).then((data) => {
            setModalLoading(false)
            if (data.tokens) {
                deleteUser(user.user).then(() => {

                })
                window.location.href = "/cms/users"
            }
            else {
                setModalError(data.detail);
            }

        });


    }

    const blockThisUser = () => {
        setModalLoading(true)
        setModalError(false)
        if (!modal_password) {
            setModalError("Please Enter Password")
            return;
        }


        login({ email: admin.email, password: modal_password }).then((data) => {

            if (data.tokens) {
                blockUser(user).then(() => {

                    if (user.is_active)
                        alert('user has been deactivated')
                    else
                        alert('user Activated')
                    let t = user
                    t.is_active = !user.is_active
                    setUser(t)
                    setModalLoading(false)
                })
                setConfirmModalIsOpen(false)
                //window.location.href = "/cms/users"
            }
            else {
                setModalError(data.detail);
            }

        });


    }

    const handleDeleteCourseParticipant = (courseParticipantId) => {
        if (window.confirm('are you sure ?')) {
            deleteCourseParticipant(courseParticipantId).then((data) => {
                _getCourseParticipants(user.user)
            });
        }

    }


    const handleFileChange = (e) => {
        var file = e.target.files[0];
        if (e.target.files) {
          setLoading(true);
          uploadProfileImage(user, file).then((response) => {
              console.log(response);
              if(response.id)
                setUser(response);
            setLoading(false);
          });
        }
      };




    return (
        <>
            <SendEmailModal to_email={user?.email} key={email_modal_is_open} onClose={closeEmailModal} name={user?.first_name} isOpen={email_modal_is_open} />
            <SendEmailComposeModal
                isOpen={composeEmailModalOpen}
                onClose={() => setComposeEmailModalOpen(false)}
                toEmail={user?.email}
                recipientName={
                    user
                        ? [user.first_name, user.last_name].filter(Boolean).join(" ").trim()
                        : ""
                }
                onSent={refreshEmails}
            />
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"> </h4>
                    </div>
                    <div class="modal-body text-center">

                        {current_document && current_document.url && current_document.url !== "undefined" && <UrlEmbed url={current_document.url} />}
                        {current_document && (!current_document.url || current_document.url === "undefined") &&
                            <>
                                {current_document && isImage(current_document.file) &&
                                    <img src={current_document && current_document.file} alt="" class="modal-img" />

                                }
                                {current_document && !isImage(current_document.file) &&
                                    <video id="modal_video" className="video" controls >
                                        <source src={current_document.file} type="video/mp4" />
                                    </video>
                                }
                            </>

                        }

                    </div>

                </div>
            </Modal>

            <Modal
                closeTimeoutMS={500}
                isOpen={confirmModalIsOpen}
                onRequestClose={closeConfirmModal}
                className="Modal confirm-modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeConfirmModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">{confirmModalType} Talent</h4>
                    </div>
                    <div class="modal-body">
                        <div className="" style={{ minHeight: 100 }}>
                            <div className="col-md-12 mb-10 text-light">
                                To confirm {confirmModalType}, Please enter your password
                            </div>
                            <div className="col-md-8">
                                <div class="input-group">
                                    <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                                    <input type="password" className="form-control modal-password" onChange={handleChange} placeholder="Password" name="modal_password" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-primary btn-rounded" onClick={modalSubmit}>{confirmModalType}</button>
                            </div>
                        </div>
                        {modal_error &&
                            <div className="alert alert-danger">
                                {modal_error}
                            </div>
                        }
                        {modal_loading &&
                            <div className="alert alert-primary text-color-light">
                                Please wait...
                            </div>
                        }
                    </div>

                </div>
            </Modal>

            <div className="content-wrapper jury-page usertalent-page">
                <section className="content-header">
                    <ol className="breadcrumb">
                        <li>
                            <a href="/cms/dashboard">
                                <i className="fa fa-dashboard" /> Home
                            </a>
                        </li>
                        <li>
                            <a href="/cms/users">
                                <i className="fa fa-users" /> Users
                            </a>
                        </li>
                        <li className="active">User talent</li>
                    </ol>
                </section>

                <section className="content">

                    <div className="modal fade" id="modal-profile-image">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 className="modal-title">
                                        {user && user.first_name + " " + user.last_name}
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <img src={user && user.image} alt={user && user.first_name + " " + user.last_name} className="img" />

                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-5">
                            <div className="cms-dark-box jury-profile-card">
                                <div className="jury-profile-top">
                                    <button
                                        type="button"
                                        className="jury-avatar-btn"
                                        onClick={() => profile_image_ref.current && profile_image_ref.current.click()}
                                        title="Change photo"
                                    >
                                        {user && (user.image || user.avatar) ? (
                                            <img className="jury-avatar" src={userAvatar(user)} alt="" />
                                        ) : (
                                            <span className="jury-avatar jury-avatar-initial" aria-hidden="true">
                                                {user
                                                    ? (() => {
                                                          const fn = (user.first_name || "").trim();
                                                          if (fn.length) return fn.charAt(0).toUpperCase();
                                                          const ln = (user.last_name || "").trim();
                                                          if (ln.length) return ln.charAt(0).toUpperCase();
                                                          const em = (user.email || "").trim();
                                                          if (em.length) return em.charAt(0).toUpperCase();
                                                          return "?";
                                                      })()
                                                    : "—"}
                                            </span>
                                        )}
                                    </button>
                                    <input
                                        ref={profile_image_ref}
                                        type="file"
                                        className="hide"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                    <div className="jury-profile-meta">
                                        <h2 className="jury-profile-name">
                                            {user && user.first_name
                                                ? `${user.first_name} ${user.last_name || ""}`
                                                : "—"}
                                        </h2>
                                        {user && user.email && (
                                            <button
                                                type="button"
                                                className="jury-profile-email-btn"
                                                onClick={openEmailModal}
                                            >
                                                {user.email}
                                            </button>
                                        )}
                                        <div className="usertalent-profile-socials">
                                            {user && user.website && (
                                                <a href={user.website} target="_blank" rel="noreferrer" title="Website" className="usertalent-social-link">
                                                    <i className="fa fa-home" />
                                                </a>
                                            )}
                                            {user && user.facebook && (
                                                <a href={user.facebook} target="_blank" rel="noreferrer" title="Facebook" className="usertalent-social-link">
                                                    <i className="fa fa-facebook" />
                                                </a>
                                            )}
                                            {user && user.instagram && (
                                                <a href={user.instagram} target="_blank" rel="noreferrer" title="Instagram" className="usertalent-social-link">
                                                    <i className="fa fa-instagram" />
                                                </a>
                                            )}
                                            {user && user.youtube && (
                                                <a href={user.youtube} target="_blank" rel="noreferrer" title="YouTube" className="usertalent-social-link">
                                                    <i className="fa fa-youtube" />
                                                </a>
                                            )}
                                            {user && user.snapchat && (
                                                <a href={user.snapchat} target="_blank" rel="noreferrer" title="Snapchat" className="usertalent-social-link">
                                                    <i className="fa fa-snapchat" />
                                                </a>
                                            )}
                                            {user && user.spotify && (
                                                <a href={user.spotify} target="_blank" rel="noreferrer" title="Spotify" className="usertalent-social-link">
                                                    <i className="fa fa-spotify" />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="usertalent-profile-detail-lines">
                                    {user?.phone_number && (
                                        <p>
                                            <span className="usertalent-detail-label">Phone</span>
                                            {user.phone_number}
                                        </p>
                                    )}
                                    {user?.birth_date && (
                                        <p>
                                            <span className="usertalent-detail-label">Date of birth</span>
                                            {user.birth_date}
                                        </p>
                                    )}
                                    <p>
                                        <span className="usertalent-detail-label">Gender</span>
                                        {user
                                            ? user.gender === 0
                                                ? "Male"
                                                : user.gender === 1
                                                ? "Female"
                                                : "Other"
                                            : "—"}
                                    </p>
                                    <p>
                                        <span className="usertalent-detail-label">From</span>
                                        {country && getDefaultName(country.names)}
                                        {" — "}
                                        <CityName key={user && user.city_id} id={user && user.city_id} />
                                    </p>
                                    <p>
                                        <span className="usertalent-detail-label">Lives in</span>
                                        {living_country && getDefaultName(living_country.names)}
                                        {" — "}
                                        <CityName key={user && user.livingcity_id} id={user && user.livingcity_id} />
                                    </p>
                                </div>
                                <ul className="jury-stat-list">
                                    <li>
                                        <span>Last login</span>
                                        <span className="jury-stat-val">
                                            {user && user.last_login ? getDate(user.last_login) : "—"}
                                        </span>
                                    </li>
                                    <li>
                                        <span>Registered</span>
                                        <span className="jury-stat-val">
                                            {user && user.created_at ? user.created_at.split(" ")[0] : "—"}
                                        </span>
                                    </li>
                                    <li>
                                        <span>Talents</span>
                                        <span className="jury-stat-val">{usertalents ? usertalents.length : "—"}</span>
                                    </li>
                                </ul>
                            </div>

                            <div className="cms-dark-box jury-contests-box">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Contests</h3>
                                </div>
                                <div className="box-body padding-0">
                                    <table className="table usertalent-contests-table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Contest</th>
                                                <th>Talent</th>
                                                <th>Rating</th>
                                                <th className="usertalent-contests-actions" />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {courseParticipants && courseParticipants.length > 0 ? (
                                                courseParticipants.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>
                                                            <a
                                                                href={`/cms/coursedetails/${item.course.id}`}
                                                                className="usertalent-contest-link"
                                                            >
                                                                {getDefaultName(item.course.names)}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {item.usertalent.talent &&
                                                                getDefaultName(item.usertalent.talent.names)}
                                                        </td>
                                                        <td>
                                                            <span className={BadgeClass(item.usertalent.rate)}>
                                                                {item.usertalent.rate &&
                                                                    item.usertalent.rate.toFixed(2)}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-cm btn-sm usertalent-contest-remove"
                                                                onClick={() => handleDeleteCourseParticipant(item.id)}
                                                                title="Remove"
                                                            >
                                                                <i className="fa fa-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="usertalent-contests-empty">
                                                        No contest entries yet.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {isAdmin() && (
                                <div className="jury-actions">
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => openConfirmModal("Delete")}
                                    >
                                        <i className="fa fa-trash" /> Delete
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-warning btn-sm"
                                        onClick={() => openConfirmModal("Ban")}
                                    >
                                        <i className="fa fa-ban" />{" "}
                                        {user && user.is_active ? "Deactivate" : "Activate"}
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="col-lg-8 col-md-7">
                            {mainTabs.length > 0 && (
                                <>
                                    <TabsWidget
                                        tabs={mainTabs}
                                        activeTab={resolvedTab}
                                        onTabChange={setActiveTab}
                                        className="cms-page-tabs usertalent-page-tabs"
                                    />
                                    <div className="cms-page-tab-content">
                                        {resolvedTab === "talents" &&
                                            (talentSubTabs.length > 0 ? (
                                                <>
                                                    <TabsWidget
                                                        tabs={talentSubTabs}
                                                        activeTab={resolvedTalentTab}
                                                        onTabChange={setActiveTalentTab}
                                                        className="cms-level2-tabs usertalent-talent-subtabs"
                                                    />
                                                    <div className="cms-level2-tab-content">
                                                        {resolvedTalentTab &&
                                                            usertalents &&
                                                            (() => {
                                                                const utId = resolvedTalentTab.replace(/^ut_/, "");
                                                                const item = usertalents.find(
                                                                    (u) => String(u.id) === utId
                                                                );
                                                                if (!item) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <div className="jury-tab-panel usertalent-talent-tab-body">
                                                                        <UserTalentSingleContent
                                                                            id={item.id}
                                                                            callback={callback}
                                                                            onDocumentsCountChange={(count) => {
                                                                                setTalentDocumentCounts((prev) => ({
                                                                                    ...prev,
                                                                                    [item.id]: count,
                                                                                }));
                                                                            }}
                                                                        />
                                                                    </div>
                                                                );
                                                            })()}
                                                    </div>
                                                </>
                                            ) : (
                                                <p className="jury-gallery-empty mb-0">
                                                    No talents registered for this user yet.
                                                </p>
                                            ))}

                                        {resolvedTab === "gallery" &&
                                            (user && user.user ? (
                                                <UserGallery userId={user.user} />
                                            ) : (
                                                <p className="jury-gallery-empty mb-0">Loading profile…</p>
                                            ))}

                                        {resolvedTab === "emails" && (
                                            <div className="jury-tab-panel">
                                                <div className="usertalent-emails-toolbar">
                                                    <h2 className="jury-tab-panel-title usertalent-emails-title">
                                                        Emails
                                                        <span className="usertalent-emails-count">
                                                            {" "}
                                                            ({emails ? emails.length : 0})
                                                        </span>
                                                    </h2>
                                                    {isAdmin() && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-cm btn-sm usertalent-emails-add-btn"
                                                            onClick={() => setComposeEmailModalOpen(true)}
                                                            title="Send email to this user"
                                                        >
                                                            <i className="fa fa-plus" /> Send email
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table usertalent-emails-table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>To</th>
                                                                <th>Subject</th>
                                                                <th>Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {emails && emails.length > 0 ? (
                                                                emails.map((item) => (
                                                                    <tr
                                                                        key={item.id}
                                                                        className={loading === item.id ? "loading" : ""}
                                                                    >
                                                                        <td>
                                                                            <a href={`/cms/email/${item.id}`}>{item.to}</a>
                                                                        </td>
                                                                        <td className='kfont'>{item.subject}</td>
                                                                        <td>
                                                                            {item.created_at.split("T")[0]}
                                                                            <br />
                                                                            {
                                                                                item.created_at.split("T")[1].split(".")[0]
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3} className="usertalent-contests-empty">
                                                                        No emails yet.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </>


    )

}
